import styled, { css } from 'styled-components'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'
import { phoneMaxWidth, fontSize } from '../../../../DashboardSettings.styles'
import Button from 'components/UI/Button/Button'

export const Wrapper = styled.div`
  width: 220px;
  margin-left: 100px;

  @media (max-width: 900px) {
    margin-left: 50px;
  }

  @media (max-width: ${phoneMaxWidth}px) {
    margin: auto;
    margin-bottom: 20px;
  }  
`

export const InputTitle = styled.div`
  font-size: 18px;
  color: ${colors.pink};
  margin-left: 10px;
  margin-bottom: 4px;
`

export const ClassBlogSection = styled.div`
  width: 220px;
  height: 86px;
  padding: 8px;
  margin-bottom: 24px;
  background-color: ${props => props.isEditMode ? colors.white : colors.paleBlue};
  border-radius: 8px;
  border: 2px solid;
  border-color: ${props => props.isEditMode ? '#dddfdf' : 'transparent'};
`

export const ClassBlogImage = styled.div`
  background-image: ${props => `url(${props.imageUrl})`};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 200px;
  height: 68px;
  display: flex;
`

export const StyledButton = styled(Button)`
  margin: auto;
`

export const ViewBlogButton = styled(Button)`
  margin: 0 0 24px 10px;
`

export const BattleControlInfo = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 10px 10px;
  color: ${colors.pink};
`

export const BattleControlText = styled.span`
  color: ${colors.white};
  font-weight: normal;
`
